import request from "@/utils/request";
import {exportFile} from "./common";

const PREFIX_URL = process.env.NODE_ENV === 'development' ? '' : ''

// 销售订单
export function getSaleOrderPage(params) {
    return  request.post('/operation/order', params)
        .then((res) => {
        return Promise.resolve(res.data);
    })
}

export function getSaleOrderDetail(marketId, orderId) {
    return request.get(`/operation/order/${marketId}/${orderId}`)
        .then((res) => {
            return Promise.resolve(res.data);
    })
}

// 发票信息列表
export function vatInvoiceInfosList(params) {
  return request.get(`/operation/vatInvoiceDataReport/vatInvoiceInfos`, {params})
      .then((res) => {
          return Promise.resolve(res.data);
  })
}

// 创建多渠道订单获取全部国家
export function getFindAllCountry() {
    return request.get(`/defaults/country/findAllCountry`)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

// 创建多渠道订单根据countryCode获取州
export function getFindProvinceByCountryCode(countryCode) {
    return request.get(`/defaults/country/findProvinceByCountryCode?countryCode=${countryCode}`)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

export function batchRequestReview(ids) {
    return request.post('/operation/order/batchRequestReview', {ids: ids})
        .then((res) => {
            return Promise.resolve(res.data);
    })
}

export function requestReview(id) {
  return request.post(`/operation/order/${id}/requestReview`);
}

export function batchMarkPromoteOrder(params) {
    return request.post('/operation/order/batchUpdateTestFee', params)
        .then((res) => {
            return Promise.resolve(res.data);
    })
}

export function unMarkPromoteOrder(id) {
  return request.post(`/operation/order/${id}/unmarkTest`)
    .then((res) => {
      return Promise.resolve(res);
    })
}

export function cancelOrder(id) {
    return request.post(`/operation/order/${id}/canceledFulfillmentOrder`)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

export function updatePromoteFee(params) {
    return request.post(`/operation/order/updateTestFee`, params)
        .then((res) => {
            return Promise.resolve(res);
        })
}

export function getFulfillmentOrder(id) {
    return request.get(`/operation/order/${id}/loadFulfillmentOrder`)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

export function getFulfillmentPreview(params) {
    return request.post(`/operation/order/getFulfillmentPreview`, params)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

export function createFulfillmentPreview(params) {
    return request.post(`/operation/order/createFulfillmentOrder`, params)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

export function createFulfillmentAddGoods(params) {
    return request.post(`/operation/order/fulfillmentListing`, params)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

export function updateOrderMemo(id, params) {
    return request.put(`/operation/order/updateMemo`, params)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

export function buildRefundOrder(id) {
    return request.get(`/operation/order/${id}/buildRefundInfo`)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

export function refund(params) {
  return request.post(`/operation/order/refund`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function getContactBuyerReasons(id) {
  return request.get(`/operation/order/${id}/contactReasons`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function contactBuyer(params) {
  return request.post(`/operation/order/contactBuyer`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function getRelatedOrder(marketId, orderId, module, ticketId) {
  return request.get(`/operation/order/relatedOrder?marketId=${marketId}&orderId=${orderId}&module=${module}&ticketId=${ticketId}`)
      .then((res) => {
        return Promise.resolve(res.data);
      })
}

export function exportOrder(params) {
  exportFile('/operation/order/export', params);
}

// 简单商品列表
export function getSimpleListings(params) {
    return request.post(`/operation/listing/simpleListings`, params)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

// 推广订单
export function getPromoteOrder(params) {
    return request.post(`/operation/testOrder`, params)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

export function exportPromoteOrder(params) {
    exportFile('/operation/testOrder/export', params);
}

export function removePromoteOrder(id) {
    return request.post(`/operation/order/${id}/unmarkTest`)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

export function batchRemovePromoteOrder(params) {
    return request.post(`/operation/order/batchUnmarkTest`, params)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

export function updatePromoteOrderMemo(params) {
  return request.put(`/operation/testOrder/updateMemo`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function importOrder(attId) {
  return request.post(`/operation/testOrder/importTestOrder?attachmentId=${attId}`)
    .then((res) => {
      return Promise.resolve(res);
    })
}

// 配送报告
export function getAmazonShipmentPage(params) {
    return request.post('/operation/amazonShipment/page', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function exportAmazonShipment(params) {
    exportFile('/operation/amazonShipment/export', params);
}

// 退货订单
export function getCustomerReturnPage(params) {
    return request.post('/operation/customerReturn/page', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function exportCustomerReturn(params) {
    exportFile('/operation/customerReturn/export', params);
}

// 换货报告
export function getReplacementOrderPage(params) {
    return request.post('/operation/replacementOrder/page', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function exportReplacementOrder(params) {
    exportFile('/operation/replacementOrder/export', params);
}

// 移除报告
export function getRemovalShipmentPage(params) {
    return request.post('/operation/removalShipment/page', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function exportRemovalShipment(params) {
    exportFile('/operation/removalShipment/export', params);
}

export function getRemovalShipmentDetail(warehouseId, orderId) {
    return request.get(`/operation/removalShipment/detail/${warehouseId}/${encodeURIComponent(orderId)}`)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

// listing
export function getListingPage(params) {
  return request.post('/operation/listing', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getListingCalculateProfitParmas(params) {
  return request.post('/operation/trialProfitLog/trial/profit', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function saveListingCalculateProfitParmas(params) {
  return request.post('/operation/trialProfitLog', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getListingCalculateProfit(id) {
  return request.get(`/operation/listing/${id}/loadProfit`)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getListingRelatePage(params) {
  return request.post('/operation/listing/listingProducts', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function batchRelateProduct(params) {
  return request.post('/operation/listing/V2/batchLinkProduct', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function relateOtherProduct(params) {
  return request.post('/operation/listing/V2/linkProduct', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}


export function otherLinkProduct(params) {
  return request.post('/operation/listing/V2/otherLinkProduct', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}



export function relateProduct(params) {
  return request.post('/operation/listing/linkProduct', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}
export function disconnectListing(id) {
  return request.post(`/operation/listing/V2/${id}/unlinkProduct`)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getListingDetail(id) {
  return request.get(`/operation/listing/${id}`)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function updateListingInfo(id, params) {
  return request.put(`/operation/listing/${id}/update`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

//批量调价
export function batchUpdatePrice(params) {
  return request.put(`/operation/listing/batchAdjustPrice`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

//单个调价
export function adjustPrice(id, params) {
    return request.post(`/operation/listing/adjustPrice/${id}`, params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function exportListing(params) {
  exportFile('/operation/listing/export', params)
}

export function importOperationState(attId) {
  return request.post(`/operation/listing/importOperationStatus?attachmentId=${attId}`)
    .then((res) => {
      return Promise.resolve(res);
    })
}

export function importRelateProduct(attId) {
  return request.post(`/operation/listing/importProductLinkTemplate?attachmentId=${attId}`)
    .then((res) => {
      return Promise.resolve(res);
    })
}

/*************************************** 运营日志 *************************************/

export function getOperationLogPage(params) {
  return request.post('/operation/operationLog/page', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getAsinOperationLogList(params) {
  return request.get('/operation/operationLog/queryAsin', {params})
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getVariationAsinOperationLogList(params) {
  return request.get('/operation/operationLog/queryVariationAsin', {params})
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getOperationLogListingPage(params) {
  return request.post('/operation/operationLog/listingPage', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function addBatchOperationLog(params) {
  return request.post('/operation/operationLog/saveBatch', params)
    .then((res) => {
      return Promise.resolve(res);
    });
}

export function addOperationLog(params) {
  return request.post('/operation/operationLog', params)
    .then((res) => {
      return Promise.resolve(res);
    });
}

export function updateOperationLog(params) {
  return request.put('/operation/operationLog', params)
    .then((res) => {
      return Promise.resolve(res);
    });
}

export function deleteOperationLog(id) {
  return request.delete(`/operation/operationLog?id=${id}`)
    .then((res) => {
      return Promise.resolve(res);
    });
}

// 索赔
export function getClaimPage(params) {
  return request.post(`/operation/claim/page`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function exportClaim(params) {
  exportFile('/operation/claim/export', params)
}

export function getClaimDetailPage(params) {
  return request.post(`/operation/claim/detailPage`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function updateClaimMemo(params) {
  return request.post(`/operation/claim/editMemo`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}
// 查看case模板
// const saf ='http://front.gerpgo.cn/mock/15/api'
export function lookTemplate(params){
  return request.post(`${PREFIX_URL}/operation/claim/transactionItemId`,params)
  .then((res)=>{
    return Promise.resolve(res.data);
  })
}

export function innerClaimData(params) {
  return request.post(`/operation/claim/editCaeId`, params)
    .then((res) => {
      return Promise.resolve(res);
    });
}

export function exportClaimDetail(params) {
  exportFile('/operation/claim/detailExport', params)
}



// 退货索赔
export function getReturnGoodsClaimPage(params) {
  return request.post(`/operation/returnedClaim/page`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

// 退货索赔统计
export function getReturnGoodsClaimStat(params) {
  return request.post(`/operation/returnedClaim/statistics`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

// 退货索赔手动刷新
export function refreshReturnGoodsClaim(params) {
  return request.post(`/operation/returnedClaim/refresh`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

// 查看退货索赔模板
export function getReturnGoodsClaimTemplate(id){
  return request.get(`${PREFIX_URL}/operation/returnedClaim/template/${id}`)
  .then((res)=>{
    return Promise.resolve(res.data);
  })
}

// 修改退货索赔
export function updateReturnGoodsClaim(params) {
  return request.post(`/operation/returnedClaim/update`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

// 库存索赔
export function getStorageClaimPage(params) {
  return request.post(`/operation/storageClaim/page`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

// 库存索赔统计
export function getStoragesClaimStat(params) {
  return request.post(`/operation/storageClaim/statistics`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

// 库存索赔手动刷新
export function refreshStorageClaim(params) {
  return request.post(`/operation/storageClaim/refresh`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

// 查看库存索赔模板
export function getStorageClaimTemplate(id){
  return request.get(`${PREFIX_URL}/operation/storageClaim/template/${id}`)
  .then((res)=>{
    return Promise.resolve(res.data);
  })
}

// 修改库存索赔
export function updateStorageClaim(params) {
  return request.post(`/operation/storageClaim/update`, params)
    .then((res) => {
      return Promise.resolve(res);
    });
}

// feedback
export function getFeedbackPage(params) {
    return request.post('/crm/feedback', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function exportFeedback(params) {
    exportFile('/crm/feedback/export', params);
}

export function editFeedbackStatus(id, status) {
    return request.put(`/crm/feedback/updateStatus/${id}/${status}`);
}

//feedback---修改跟踪结果
export function updateLastResult(id, lastResult) {
    return request.put(`/crm/feedback/updateLastResult?id=${id}&lastResult=${lastResult}`)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

// review
export function getReviewPage(params) {
    return request.post('/crm/review', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function exportReview(params) {
    exportFile('/crm/review/export', params);
}

export function editReviewStatus(id, status) {
    return request.put(`/crm/review/updateStatus/${id}/${status}`);
}

//review---详情页批量操作
export function batchOperationEmail(params) {
    return request.post('/crm/reviewRelateOrder/batchOperationEmail', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

//review---详情页单个操作
export function singleOperationEmail(relateOrderId,type) {
    return request.get(`/crm/reviewRelateOrder/singleOperationEmail/${relateOrderId}?type=${type}`)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

//review---修改跟踪结果
export function updateTrackingResul(id, lastResult) {
    return request.put(`/crm/review/updateTrackingResult?id=${id}&lastResult=${lastResult}`);
}
//review---详情页
export function getReviewDetail(id) {
    return request.get(`/crm/review/${id}/detail`)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}



export function getReviewDetailMatchOrder(id) {
    return request.get(`/crm/review/${id}/listMatchOrders`)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function getListingTag(id,name,marketId){
  return request.get(`/crm/feedback/getListing?orderId=${id}&module=${name}&marketId=${marketId}`)
  .then((res)=>{
    return Promise.resolve(res.data)
  })
}


export function reviewAddMatchOrder(params) {
    return request.post(`/crm/review/addMatchOrders`, params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

// 匹配订单推荐列表
export function getMatchOrderList(id){
    return request.get(`/crm/review/${id}/matchOrderList`)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

// 操作是否采纳
export function operateAdopt(params){
    return request.post(`/crm/review/operateAdopt`, params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function reviewRemoveOrder(params) {
    return request.post(`/crm/review/removalMatchOrder`, params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function printListingLabels(params) {
  return request.post(`/operation/listing/printListingLabels`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

/**
 * 获取产品负责人列表
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getChargerList (params) {
  return request.get(`${PREFIX_URL}/operation/listingCharge/getListingChargerList`, { params })
    .then(res => res.data)
}

/**
 * 添加产品负责人
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function postAddCharger (params) {
  return request.post(`${PREFIX_URL}/operation/listingCharge/addListingCharge`, params)
    .then(res => res.data)
}

/**
 * 导入产品负责人
 * @param attachmentId
 * @returns {Promise<AxiosResponse<any>>}
 */
export function postChargeInfo (attachmentId) {
  return request.post(`${PREFIX_URL}/operation/listing/importProductChargeInfo?attachmentId=${attachmentId}`)
    .then(res => res)
}

/**
 * 全部asin列表
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function allAsin(params) {
    return request.post(`${PREFIX_URL}/operation/listing/allAsinPage`, params)
        .then(res => res.data)
}

// 同步商品
export function syncListing(params) {
  return request.post('/operation/listing/syncListing', params).then(res => res.data)
}

export function syncListingGoodsDetail(params) {
  return request.get(`/operation/listingEdit/${params}`).then(res => res.data)
}

export function syncLSaveListingGoods(params) {
  return request.post('/operation/listingEdit/edit', params).then(res => res.data)
}
export function syncGetListingV2(params) {
  return request.post('/operation/listing/v2', params).then(res => res.data)
}

export function getListItem(params) {
  return request.post('/operation/listing/V2/Variants', params).then(res => res.data)
}

export function editGoodTitle(params) {
  return request.post('/operation/listingEdit/editTitle', params).then(res => res.data)
}
export function editGoodPrice(params) {
  return request.post('/operation/listingEdit/adjustSalePrice', params).then(res => res.data)
}
export function editGoodB2bPrice(params) {
  return request.post('/operation/listingEdit/adjustB2BPrice', params).then(res => res.data)
}

export function editGoodStorage(params) {
  return request.post('/operation/listingEdit/editFulfillment', params).then(res => res.data)
}

export function editBatchEditFulfillment(params) {
  return request.post('/operation/listingEdit/batchEditFulfillment', params).then(res => res.data)
}
export function batchUnlinkProduct(params) {
  return request.post('/operation/listing/V2/batchUnlinkProduct', params).then(res => res.data)
}

export function batchEditMfnQuantityDetail(params) {
  return request.post('/operation/listingEdit/batchEditMfnQuantityDetail', params).then(res => res.data)
}

// 修改负责人
export function editGoodsCharge (params) {
  return request.post('/operation/listingEdit/editCharge', params).then(res => res.data)
}

// 修改运营状态
export function editOperationStatus (params) {
  return request.post('/operation/listingEdit/editOperationStatus', params).then(res => res.data)
}
